import clsx from 'clsx';
import React from 'react';
import FilterChip from './FilterChip';
import { useHistory } from 'react-router-dom';

type Props = {
  filterKeywords?: Array<{
    word: string;
    href?: string;
    onRemove?: () => void;
  }>;
  className?: string;
  resultCount: string;
};
/**
 * @param  filterKeywords is an array of filter keywords, it contains the word, href link to page of items related to the keyword.
 * @param className is a string containing classes you want to add to component wrapper.
 * @param resultCount is the number of items found related to all filter keywords, its default value is zero (0).
 * @example <ActiveFilter className="bg-red" filterKeywords={[{
            word: "drugs",
            href?: "products/drugs",
        },
        {
            word: "paracetamol",
            href?: "products/drugs",
        }]
        }
        resultCount={50}
        />
*/

export const ActiveFilterBar = ({
  filterKeywords,
  className = '',
  resultCount = '0',
}: Props) => {
  const wrapperClass = clsx(
    'px-4 py-1 w-full border border-border bg-[#F2F4F5] shadow-sm dark:bg-transparent rounded-sm',
    'flex items-center flex-nowrap justify-start gap-4 overflow-x-auto overflow-y-hidden *:text-nowrap *:min-w-fit',
    className
  );
  const history = useHistory();
  const handleChipSelection = (href?: string) => {
    if (href) return history.push(href);
    return;
  };
  return (
    <nav className={wrapperClass}>
      <p className="medium-emphasis-text ">Active Filters:</p>
      <>
        {filterKeywords &&
          filterKeywords.map(({ word, href, onRemove }) => {
            if (!word) return null;
            return (
              <FilterChip
                key={word}
                label={word}
                clickable={!!href}
                removable={true}
                onClick={() => handleChipSelection(href)}
                onRemove={() => onRemove?.()}
              />
            );
          })}
      </>
      <div className="flex-1 overflow-x-auto overflow-y-hidden ">
        <p className="ml-auto w-fit space-x-1 ">
          <span className="font-medium !text-text-dark-high dark:!text-text-light-high">
            {resultCount}
          </span>
          <span className="!text-text-dark-medium dark:!text-text-light-medium ">
            Result found
          </span>
        </p>
      </div>
    </nav>
  );
};
export default ActiveFilterBar;
